export default __webpack_public_path__ + "static/media/menu.35497337.svg";